const valueText = (value) => (value == null ? '' : String(value));

export const isAuditPlatformServiceOption = (service = {}) => {
  const normalized = [
    service.name,
    service.label,
    service.serviceName,
    service.service_name,
    service.category,
    service.serviceCategory,
    service.service_category,
  ]
    .map(valueText)
    .join(' ')
    .trim()
    .toLowerCase();

  return normalized.includes('certification') || normalized.includes('sustainability');
};

export const buildAuditModeLeadOptions = (options = {}, auditMode = false) => {
  if (!auditMode) return options;

  return {
    ...options,
    servicesOptions: (options.servicesOptions || []).filter(isAuditPlatformServiceOption),
  };
};
